import { render, staticRenderFns } from "./DropdownForm.vue?vue&type=template&id=23d210b6&scoped=true"
import script from "./DropdownForm.vue?vue&type=script&lang=js"
export * from "./DropdownForm.vue?vue&type=script&lang=js"
import style0 from "./DropdownForm.vue?vue&type=style&index=0&id=23d210b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d210b6",
  null
  
)

export default component.exports